import React from 'react';
import { toast } from 'react-toastify';
import { MdCheckCircle, MdError, MdWarning, MdInfo } from 'react-icons/md';

const notify = ({ message, type }) => {
  const CONFIG = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  }

  const renderToastContent = (title, icon, iconColorClass) => (
    <div className="flex items-center gap-3">
      <div className={`p-2 rounded-xl flex-shrink-0 ${iconColorClass}`}>
        {icon}
      </div>
      <div className="flex flex-col">
        <span className="font-bold text-xs uppercase tracking-wider text-gray-400">{title}</span>
        <span className="text-sm font-semibold text-gray-900 leading-tight mt-0.5">{message}</span>
      </div>
    </div>
  )

  switch (type) {
    case "success":
      toast.success(
        renderToastContent("Success", <MdCheckCircle size={20} className="text-emerald-500" />, "bg-emerald-50"),
        CONFIG
      )
      break

    case "error":
      toast.error(
        renderToastContent("Error", <MdError size={20} className="text-rose-500" />, "bg-rose-50"),
        CONFIG
      )
      break

    case "warning":
      toast.warning(
        renderToastContent("Notice", <MdWarning size={20} className="text-amber-500" />, "bg-amber-50"),
        CONFIG
      )
      break

    default:
      toast.info(
        renderToastContent("Notification", <MdInfo size={20} className="text-blue-500" />, "bg-blue-50"),
        CONFIG
      )
      break
  }
}

export default notify;